enum SectionType {
  PLUGGED = 'PLUGGED',
  UNPLUGGED = 'UNPLUGGED',
  LOSING_DATA = 'LOSING_DATA',
}

export default SectionType;
